export enum ReferenceSummaryType {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  SAME_DOCUMENT = 'SAME_DOCUMENT',
}
